<template>

  <Form
    :title="$t('Website / Social')"
    :creating="creating"
    :loading="loading">
    <form
      id="social-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveSocial(social)">
      <div class="form-group">
        <label>Company Website</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          placeholder="http://www.companyname.com.br"
          v-model="social.website">
        <ValidateMessage :error="validateErrors['social.website']" />
      </div>
      <div class="form-group">
        <label>Twitter</label>
        <input
          type="text"
          class="form-control"
          placeholder="https://twitter.com/companyname"
          v-model="social.twitter">
        <ValidateMessage :error="validateErrors['social.twitter']" />
      </div>
      <div class="form-group">
        <label>Facebook</label>
        <input
          type="text"
          class="form-control"
          placeholder="https://www.facebook.com/companyname"
          v-model="social.facebook">
        <ValidateMessage :error="validateErrors['social.facebook']" />
      </div>
      <div class="form-group">
        <label>LinkedIn</label>
        <input
          type="text"
          class="form-control"
          placeholder="https://br.linkedin.com/company/companyname"
          v-model="social.linkedin">
        <ValidateMessage :error="validateErrors['social.linkedin']" />
      </div>
      <div class="form-group">
        <label>Instagram</label>
        <input
          type="text"
          class="form-control"
          placeholder="https://www.instagram.com/companyname"
          v-model="social.instagram">
        <ValidateMessage :error="validateErrors['social.instagram']" />
      </div>
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="social-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'AccountSocial',
  components: {
    Form
  },
  data () {
    return {
      creating: true,
      loading: false,
      social: {
        website: null,
        twitter: null,
        facebook: null,
        linkedin: null,
        instagram: null
      },
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountSocial', this.account._id)
      .then(result => {
        this.social = result.social
        this.creating = false
      })
    },
    saveSocial (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountSocial', {
        _id: this.account._id,
        social: data
      })
      .then((result) => {
        this.social = result.social
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountSocial.vue